import { VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import React from 'react';

import { NotFoundTable, ProductFieldProps } from '../../constants';

import { AssetPrincipalCard, AssetWithDocument } from './components/AssetPrincipalCard';

export interface ProductTableMobileProps<T> {
  data: T[];
  fields: ProductFieldProps<T>[];
  onSelectClient: (cpfCnpj: string) => void;
}

export const ProductTableMobile = <T extends AssetWithDocument>({
  data,
  fields,
  onSelectClient,
}: ProductTableMobileProps<T>) => {
  if (data.length === 0) {
    return <NotFoundTable />;
  }

  return (
    <VStack space={Spacing['stack.xxxs']} pb={Spacing['stack.xxxs']}>
      {data.map((item, index) => (
        <AssetPrincipalCard
          key={index.toString()}
          item={item}
          infos={fields}
          onSelectClient={onSelectClient}
        />
      ))}
    </VStack>
  );
};
